import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ZtoolSnackAlert } from '@zippeditoolsjs/blocks';
import { setSnackAlert } from 'core/slices/snackAlert';

const SNACK_DURATION = 3000;
const CLOSED_SNACK = { open: false, severity: null, message: null };

export default function SnackAlert() {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.snackAlert.snack?.open);
  const translationKey = useSelector((state) => state.snackAlert.snack?.translation_key);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      dispatch(setSnackAlert(CLOSED_SNACK));
    }, SNACK_DURATION);
    return () => clearTimeout(timerRef.current);
  }, [open, translationKey]);

  return <ZtoolSnackAlert />;
}
